// #region Imports
import React, { useEffect, useState } from 'react';
import useFuncionarios from '../../hooks/useFuncionarios';
import FuncionariosTable from '../../components/Funcionarios/FuncionariosTable/FuncionariosTable';
import FuncionarioCrud from '../../components/Funcionarios/FuncionarioCrud/FuncionarioCrud';
// #endregion

export default function FuncionariosPage() {
  // #region Hook de dados
  const { listar, obter, criar, atualizar, remover, funcionarios, loading } = useFuncionarios();
  // #endregion

  // #region Estado UI
  const [filters, setFilters] = useState({ q: '', status: 'TODOS', cargo: 'TODOS' });
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [listState, setListState] = useState({ data: [], total: 0 });
  const [editingId, setEditingId] = useState(null);
  const [crudOpen, setCrudOpen] = useState(false);
  // #endregion

  // #region Efeitos
  useEffect(() => {
    const res = listar({ ...filters, page, pageSize });
    setListState(res);
  }, [listar, filters, page, pageSize]);
  // #endregion

  // #region Handlers
  function handleFiltersChange(next) { setFilters(next); setPage(1); }
  function handleCreate() { setEditingId(null); setCrudOpen(true); }
  function handleEdit(id) { setEditingId(id); setCrudOpen(true); }
  function handleDelete(id) { remover(id); const res = listar({ ...filters, page, pageSize }); setListState(res); }
  function handleSave(payload) {
    if (editingId) { atualizar(editingId, payload); } else { criar(payload); }
    const res = listar({ ...filters, page, pageSize });
    setListState(res);
  }
  // #endregion

  // #region Derivados
  const editing = editingId ? obter(editingId) : null;
  const cargos = Array.from(new Set(funcionarios.map(f => f.cargo).filter(Boolean))).sort();
  // #endregion

  // #region Render
  return (
    <div className="funcionarios-page">
      <FuncionariosTable
        loading={loading}
        filters={filters}
        cargos={cargos}
        data={listState.data}
        total={listState.total}
        page={page}
        pageSize={pageSize}
        onFiltersChange={handleFiltersChange}
        onPageChange={p => setPage(p)}
        onCreate={handleCreate}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
      <FuncionarioCrud
        open={crudOpen}
        funcionario={editing}
        onClose={() => setCrudOpen(false)}
        onSave={handleSave}
      />
    </div>
  );
  // #endregion
}
